<template>
  <div class="footer-box">
    <el-row>
      <el-col :span="13" class="tel">
        <div @click="handleOpenPhone">
          电话咨询 400-600-7966
        </div>
      </el-col>
      <el-col :span="11" class="btn-submit">
        <div @click="handleFooter">
          立即体验
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: "PhoneFooter",
    data () {
      return {}
    },
    methods: {
      handleOpenPhone () {
        window.location.href = 'tel://400-600-7966';
      },
      handleFooter () {
        this.$emit('handleFooter')
      }
    }
  }
</script>

<style scoped>
  .footer-box{position: fixed;bottom: 0;width: 100%;font-size: 16px;line-height: 53px;text-align: center;z-index: 7}
  .tel{background: #DCE9FF;color: #186CF5;height: 53px}
  .btn-submit{background: linear-gradient(to right, #106CEC, #0191FF);height: 53px;color: #ffffff}
</style>



// WEBPACK FOOTER //
// src/components/include/PhoneFooter.vue